import { useUserPrefs } from "@strat/ui";

import { Card } from "../shell/ui";
import { DASHBOARD_CARDS, arrangeCards, moveCard, setCardVisible } from "./dashboardCards";

/** Settings → Dashboard: which cards the Dashboard shows, and in what order — the same as its Customize mode. */
export function DashboardSettings() {
  const { prefs, update } = useUserPrefs();
  const arranged = arrangeCards(prefs.dashboard.cards);
  return (
    <Card title="Dashboard" id="dashboard">
      <p className="muted small">The cards on the Dashboard, top to bottom.</p>
      <ul className="settings-list">
        {arranged.map((c, i) => {
          const title = DASHBOARD_CARDS.find((d) => d.id === c.id)!.title;
          return (
            <li key={c.id}>
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={c.visible}
                  onChange={(e) => update((p) => setCardVisible(p, c.id, e.target.checked))}
                />
                {title}
              </label>
              <span className="row" style={{ gap: "0.2rem" }}>
                <button
                  type="button"
                  className="btn btn--sm btn--ghost"
                  aria-label={`Move ${title} up`}
                  disabled={i === 0}
                  onClick={() => update((p) => moveCard(p, c.id, -1))}
                >
                  ↑
                </button>
                <button
                  type="button"
                  className="btn btn--sm btn--ghost"
                  aria-label={`Move ${title} down`}
                  disabled={i === arranged.length - 1}
                  onClick={() => update((p) => moveCard(p, c.id, 1))}
                >
                  ↓
                </button>
              </span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
